import { useEffect, useRef, useState } from "react";
import { ASSETS, Chapter, Reveal } from "../presentation";

export default function S05Wetra() {
  const [open, setOpen] = useState(false);
  const bgRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  /* keep the background video playing at all times */
  useEffect(() => {
    const v = bgRef.current;
    if (!v) return undefined;
    const resume = () => {
      if (v.paused) {
        const p = v.play();
        if (p && typeof p.catch === "function") p.catch(() => {});
      }
    };
    resume();
    v.addEventListener("pause", resume);
    document.addEventListener("visibilitychange", resume);
    return () => {
      v.removeEventListener("pause", resume);
      document.removeEventListener("visibilitychange", resume);
    };
  }, [open]);

  return (
    <section id="wetra" className="about-immersive theme-dark" data-testid="slide-wetra">
      <div className="about-immersive-media media-right" data-testid="wetra-media">
        <video
          ref={bgRef}
          src="/wetra-bg.mp4"
          poster="/wetra-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="Sunreef Wetra console"
          data-testid="wetra-video"
        />
      </div>
      <div className="about-immersive-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="04" label="intelligent yacht control" testid="wetra-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content">
          <Reveal><span className="eyebrow">.sunreef wetra</span></Reveal>
          <Reveal delay={1}>
            <h2 className="editorial editorial-lg" data-testid="wetra-headline">
              Sunreef WETRA : <span className="gold">one touch, total control.</span>
            </h2>
          </Reveal>

          <Reveal className="bullet-list bullet-list-onimage" as="ul" delay={2} testid="wetra-list">
            <li data-testid="wetra-bullet-1">Industry first : 60&Prime; ultrawide main console</li>
            <li data-testid="wetra-bullet-2">Remote access from anywhere via the Sunreef WETRA mobile app</li>
            <li data-testid="wetra-bullet-3">One touch = total control of all systems on board</li>
          </Reveal>

          <Reveal delay={3} style={{ marginTop: "clamp(24px, 3vw, 40px)" }}>
            <button
              type="button"
              className="pill"
              onClick={() => setOpen(true)}
              data-testid="wetra-play-btn"
            >
              Play video <span className="arrow">→</span>
            </button>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" aria-hidden="true"></span>
        </div>
      </div>

      {open && (
        <div
          className="video-modal"
          role="dialog"
          aria-label="Sunreef Wetra video"
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
          data-testid="wetra-video-modal"
        >
          <button
            type="button"
            className="video-modal-close"
            onClick={() => setOpen(false)}
            aria-label="Close video"
            data-testid="wetra-video-close"
          >
            ×
          </button>
          <video
            src={ASSETS.wetraVideo}
            autoPlay
            controls
            playsInline
            data-testid="wetra-modal-video"
          />
        </div>
      )}
    </section>
  );
}
